export * from './charge-point-capi-details-widget'
